import { useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/common/Breadcrumb';
import CSVUpload from '@/components/common/CSVUpload';
import { useToast } from '@/components/common/Toast';
import { ParsedCSVData } from '@/types/upload';
import { validateSpecialCsv } from '@/utils/specialCsvValidation';

const SpecialUpload = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleUploadSuccess = (_data: ParsedCSVData) => {
    showToast('アップロードを受け付けました。処理状況はアップロード一覧で確認してください');
    navigate('/upload-management/new');
  };

  return (
    <div>
      <Breadcrumb />
      <div className="card max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-admin-text mb-2">特集ページCSVアップロード</h1>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-admin-text mb-2">
            📋 CSVファイルのフォーマットと注意事項
          </h2>
          <ul className="text-sm text-admin-textLight space-y-1 list-disc list-inside">
            <li>
              ファイル形式：CSV形式（.csv）のみ / サイズ 10MB 以下 / 文字コード UTF-8（BOM
              可）または Shift_JIS
            </li>
            <li>
              Book / Product と同じ 3 行構成：1 行目＝定義名 / 2 行目＝日本語表示名 / 3
              行目以降＝データ
            </li>
            <li>1 ファイル = 1 特集ページ。PAGE 行は 3 行目に 1 行のみ（特集メタ）</li>
            <li>
              data_type は PAGE / BLOCK / ITEM（行順がそのまま表示順。ITEM は直前 BLOCK 配下）
            </li>
            <li>
              special_type は product（作品特集）/ campaign（施策）。product のとき series_name 必須
            </li>
            <li>
              special_name / block_id / product_group は a-z / 0-9 / _ / - のみ（block_id
              は特集内で一意）
            </li>
            <li>
              block_type は static / static_combine / slide /
              static_with_slide（item_type との組合せに制限あり。static_combine は image / banner
              のみ 1 件以上。static_with_slide は product_detail のみで、各アイテムに続巻リストが付く）
            </li>
            <li>
              item_type は image / banner / txt / btn / product / product_detail / coupon /
              youtube（youtube は item に YouTube URL を指定。product は作品カード・
              product_detail は単品紹介で、1 ブロックに複数指定可）
            </li>
            <li>
              platform は 3 桁（web/ios/android, 1=表示/0=非表示。000 は不可。PAGE 必須・BLOCK /
              ITEM は省略時に上位を継承）
            </li>
            <li>
              色列（background_color / fbtn_background 等）は #RRGGBB 形式。空欄はシステム既定色
            </li>
          </ul>
        </div>

        <CSVUpload
          uploadType="Special"
          customValidate={validateSpecialCsv}
          onUploadSuccess={handleUploadSuccess}
        />

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => navigate('/upload-management/new')}
            className="px-6 py-2 border border-gray-300 text-admin-text rounded-lg hover:bg-gray-50 transition-colors"
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpecialUpload;
